import React from 'react';
import FinancePosting from "./Post_Receipt_Finance";
import '../../../CommonCSS/SocietyCSS.css'

const Post_Rcpt_FinanceApp = () => {
  return (
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Post Fee Receipts in Finance </h5>
          </div>  
        </div>
        <FinancePosting/>
      </div>
    </div >
  );
};

export default Post_Rcpt_FinanceApp;
